import { Module } from '../Module';
import { Sites } from '../resources/Sites';
import { SitesContentType } from './ContentTypes';
import { IPlace, Place, Subplace } from './IPlace';

export class SitesPlace {

  private urlParamsFn: () => _.Dictionary<any>;

  public static $inject = [
    '$location',
    'Sites'
  ];

  constructor(
    private $location: ng.ILocationService,
    private Sites: Sites
  ) {
    this.urlParamsFn = () => this.$location.search();
  }

  public create(): IPlace {
    const place = new Place('sites');

    place.addSubplace(Subplace.create(
      'sites',
      SitesContentType,
      this.Sites,
      this.urlParamsFn));

    return place;
  }

}

Module.instance().service('SitesPlace', SitesPlace);
